const toNumeric =  (val: string) =>
  val ?
    val
    .split('')
    .reduce(
      (collection, next) => collection + next.charCodeAt(0),
      0
    ) : 0

export default toNumeric



// WEBPACK FOOTER //
// ./src/utils/string-num-val.ts